import { render, staticRenderFns } from "./trendInfoDY.vue?vue&type=template&id=b126316e&scoped=true"
import script from "./trendInfoDY.vue?vue&type=script&lang=js"
export * from "./trendInfoDY.vue?vue&type=script&lang=js"
import style0 from "./trendInfoDY.vue?vue&type=style&index=0&id=b126316e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b126316e",
  null
  
)

export default component.exports